// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b55fa89e","703":"08022534","787":"8ec4eab0"}[chunkId] + ".chunk.js";
};